import { NewApiUserService } from '@brunsker/libs/portal-do-vendedor/utils/portal-do-vendedor-new-api';
import { Router } from '@angular/router';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UtilsBsHotToastService } from '@brunsker/libs/core/utils/hot-toast/src';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable()
export class HandleErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly toastService: UtilsBsHotToastService,
    private router: Router,
    readonly newApiUserService: NewApiUserService
    ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.error instanceof ErrorEvent) {
          this.toastService.showError(error.error.message);
          return throwError(() => error.error.message);
        }

        switch (error.status) {
          case HttpStatusCode.BadRequest: {
            if (Array.isArray(error.error)) {
              error.error.forEach(e => {
                const message = e?.message;
                this.toastService.showError(message);
              });
            } else {
              const message =
              error?.error?.message ||
              'Houve um erro ao realizar a operação. Por favor, tente novamente.';
            this.toastService.showError(message);
            }
            break;
          }
          case HttpStatusCode.Unauthorized: {
            const message =
              error?.error?.message ||
              'Não autorizado, verifique seus dados para realizar esta operação.';
              this.toastService.showError(message);
              this.newApiUserService.logoff();
              this.router.navigateByUrl('/auth');
            break;
          }
          case HttpStatusCode.Forbidden:
            this.toastService.showError(
              'Você não tem permissão para realizar esta operação.'
            );
            break;
          case HttpStatusCode.NotFound:
            this.toastService.showError(
              'Não foi possível encontrar o recurso solicitado.'
            );
            break;
          case HttpStatusCode.MethodNotAllowed:
            this.toastService.showError('Método de requisição não permitido.');
            break;
          case HttpStatusCode.GatewayTimeout:
            this.toastService.showError(
              'Erro no servidor, tempo de resposta excedido.'
            );
            break;
          default:
            this.toastService.showError(
              'Houve um erro ao realizar a operação. Por favor, tente novamente.'
            );
            break;
        }

        return throwError(() => error);
      })
    );
  }
}
